import SiafLiteApiRepository from "../../external/siafLiteApi";

class SaldoInicialService {
  constructor() {
    this.urlBase = "/estoque/saldo-inicial";
    this.urlBaseEvent = `/event${this.urlBase}`;
  }

  getById(id) {
    return new SiafLiteApiRepository(this.urlBaseEvent).getById(id);
  }

  getAll(filter) {
    return new SiafLiteApiRepository(this.urlBaseEvent).get(filter);
  }

  cadastrar(body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).post(body);
  }

  atualizar(id, body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).put(id, body);
  }

  getAllFiltroAvancado(body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).patch(body);
  }

  cadastrarEmMassa(body) {
    return new SiafLiteApiRepository(`${this.urlBaseEvent}/em-massa`).post(body);
  }
}

export default SaldoInicialService;
